import React, { Component } from "react";
import CartContext from "./CartContext";
import { Link, Navigate } from "react-router-dom";
import { Form, Button, Alert, Card } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";

export default class UserLogin extends Component {
  static contextType = CartContext;

  render() {
    return (
      <>
        <div
          className="min-vh-100 d-flex align-items-center justify-content-center px-3"
          style={{
            background:
              "radial-gradient(1200px 600px at 10% -10%, #e7f1ff 0%, transparent 60%), radial-gradient(1200px 600px at 110% 110%, #eaf7ff 0%, transparent 60%), linear-gradient(180deg, #ffffff 0%, #f7fafc 100%)",
          }}
        >
          <div style={{ width: "100%", maxWidth: 960 }}>
            <div className="row g-4 align-items-stretch">
              {/* Brand / intro panel (desktop only) */}
              <div className="col-lg-6 d-none d-lg-block">
                <div
                  className="h-100 rounded-4 p-4 p-xl-5"
                  style={{
                    background:
                      "linear-gradient(135deg, #0d6efd 0%, #6ea8fe 100%)",
                    color: "#fff",
                    boxShadow: "0 10px 30px rgba(13,110,253,.25)",
                  }}
                >
                  <div className="d-flex align-items-center gap-3 mb-4">
                    <img
                      src="/logo1.png"
                      alt="ElasticCART"
                      width={60}
                      height={60}
                      style={{
                        borderRadius: 12,
                        background: "rgba(255,255,255,.15)",
                        padding: 6,
                      }}
                    />
                    <div>
                      <h3 className="mb-0 fw-bold">ElasticCART</h3>
                      <small className="opacity-75">Admin ERP Portal</small>
                    </div>
                  </div>

                  <h4 className="fw-semibold mb-3">Welcome back 👋</h4>
                  <p className="opacity-90 mb-4">
                    Sign in to manage warehouse, suppliers, purchases,
                    production, products, sales, orders, services,
                    reconciliations, customers, employeees, projects and
                    analytics in one workspace.
                  </p>

                  <ul className="list-unstyled small opacity-90 mb-0">
                    <li className="d-flex align-items-start gap-2 mb-2">
                      <span className="badge bg-light text-primary rounded-pill">
                        1
                      </span>
                      Secure SSO & role-based access
                    </li>
                    <li className="d-flex align-items-start gap-2 mb-2">
                      <span className="badge bg-light text-primary rounded-pill">
                        2
                      </span>
                      Real-time dashboards & alerts
                    </li>
                    <li className="d-flex align-items-start gap-2">
                      <span className="badge bg-light text-primary rounded-pill">
                        3
                      </span>
                      Seamless Solution to Manufacturers, Retailers and Service
                      Providers
                    </li>
                  </ul>

                  <div className="mt-5 pt-2 small opacity-75">
                    © {new Date().getFullYear()} ElasticCART
                  </div>
                </div>
              </div>

              {/* Login card */}
              <div className="col-lg-6">
                <Card className="border-0 rounded-4 shadow-sm">
                  <Card.Body className="p-4 p-xl-5">
                    <div className="d-flex align-items-center gap-2 mb-3 d-lg-none">
                      <img
                        src="/logo192.png"
                        alt="ElasticCART"
                        width={28}
                        height={28}
                        style={{ borderRadius: 8 }}
                      />
                      <h5 className="mb-0 fw-semibold">
                        ElasticCART – Sign in
                      </h5>
                    </div>
                    <h1 className="h4 fw-bold mb-4 text-center">Login</h1>
                    <Login loggedIn={this.props.loggedIn} />
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

class Login extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      emailId: "",
      password: "",
      isValidLogin: false,
      loginResultText: "",
      userData: null,
      loading: false,
      showPwd: false,
      remember: true,
      error: "",
    };
  }

  componentDidMount() {
    const el = document.getElementById("userid");
    if (el) el.focus();
  }

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState({
      [name]: type === "checkbox" ? checked : value,
      loginResultText: "",
      error: "",
    });
  };

  // Better fetch handling with status checks
  ValidateLogin = async (emailId, password) => {
    const newSessionId = uuidv4(); // ✅ Generate a unique sessionId

    this.setState({ loading: true, error: "", loginResultText: "" });

    try {
      const res = await fetch(
        (process.env.REACT_APP_API || "") + "AdminUsers/Login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            storeId: this.context.storeId,
            emailId,
            password,
            sessionId: newSessionId, // ✅ Send sessionId to backend
          }),
        }
      );
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || "Login failed");
      }

      // ✅ Store session in state/context
      this.setState({
        isValidLogin: true,
        loginResultText: "Login success!",
        userData: data,
        loading: false,
      });
      this.context.storeUserData(data);
      if (window.innerWidth > 900 && this.props.loggedIn) {
        this.props.loggedIn(true);
      }
    } catch (err) {
      console.error("Login error:", err);
      this.setState({
        isValidLogin: false,
        error: err.message,
        loading: false,
      });
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { emailId, password } = this.state;

    if (!emailId?.trim() || !password?.trim()) {
      this.setState({ error: "Please enter both UserID and Password." });
      return;
    }
    this.ValidateLogin(emailId.trim(), password);
  };

  render() {
    // Redirects preserved
    if (this.state.isValidLogin === true) {
      if (this.context.prevPage) {
        const prevPage = this.context.prevPage;
        if (this.context.storePreviousPage) this.context.storePreviousPage("");
        return <Navigate to={prevPage} />;
      }
      return (
        <Navigate to={window.innerWidth > 900 ? "/home" : "/HomeMobileFront"} />
      );
    }

    const {
      emailId,
      password,
      loading,
      error,
      loginResultText,
      showPwd,
      remember,
    } = this.state;

    return (
      <>
        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}

        {loginResultText && !error && (
          <Alert variant="success" className="mb-3">
            {loginResultText}
          </Alert>
        )}

        <Form onSubmit={this.handleSubmit} noValidate>
          {/* UserID */}
          <div className="form-floating mb-3">
            <Form.Control
              size="lg"
              type="text"
              id="userid"
              name="emailId"
              placeholder="Enter your UserID"
              value={emailId}
              onChange={this.handleChange}
              autoComplete="username"
              required
            />
            <Form.Label htmlFor="userid">UserID</Form.Label>
          </div>

          {/* Password + show/hide */}
          <div className="form-floating mb-3 position-relative">
            <Form.Control
              size="lg"
              type={showPwd ? "text" : "password"}
              id="password"
              name="password"
              placeholder="Enter Password"
              value={password}
              onChange={this.handleChange}
              autoComplete="current-password"
              required
              minLength={6}
            />
            <Form.Label htmlFor="password">Password</Form.Label>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary position-absolute top-50 end-0 translate-middle-y me-2"
              onClick={() => this.setState((s) => ({ showPwd: !s.showPwd }))}
              aria-label={showPwd ? "Hide password" : "Show password"}
            >
              {showPwd ? "Hide" : "Show"}
            </button>
          </div>

          {/* <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="remember"
                name="remember"
                checked={remember}
                onChange={this.handleChange}
              />
              <label className="form-check-label" htmlFor="remember">
                Remember me
              </label>
            </div>
            <Link to="/forgot-password" className="link-primary small">
              Forgot password?
            </Link>
          </div> */}

          <div className="d-grid">
            <Button
              type="submit"
              className="py-2 fw-semibold"
              variant="primary"
              disabled={loading}
            >
              {loading ? (
                <span className="d-inline-flex align-items-center gap-2">
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Signing you in…
                </span>
              ) : (
                "Sign in"
              )}
            </Button>
          </div>
        </Form>

        <p className="text-muted small mt-4 mb-5 text-center">&nbsp;</p>
        <p className="text-muted small mt-4 mb-5 text-center">
          By continuing you agree to the <a href="#">Terms</a> and{" "}
          <a href="#">Privacy Policy</a>.
        </p>

        {/* Optional SSO divider */}
        {/* <div className="text-center my-3 d-flex align-items-center">
          <hr className="flex-grow-1" />
          <span className="px-3 text-muted small">or</span>
          <hr className="flex-grow-1" />
        </div>

        <div className="d-grid gap-2">
          <Button variant="outline-secondary" type="button">
            Continue with Google
          </Button>
          <Button variant="outline-secondary" type="button">
            Continue with Microsoft
          </Button>
        </div>

        <p className="text-muted small mt-4 mb-0 text-center">
          By continuing you agree to the <a href="#">Terms</a> and{" "}
          <a href="#">Privacy Policy</a>.
        </p> */}
      </>
    );
  }
}
